import React from 'react';
export function Guarantee() {
  return <section className="w-full px-4 sm:px-6 lg:px-8 py-10 text-gray-900" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(255,255,255) 0%, rgb(255,255,255) 85%, rgb(240,249,255) 100%)'
  }} data-id="element-177">
      <div className="mx-auto max-w-2xl" data-id="element-178">
        <div className="rounded-2xl overflow-hidden shadow-sm text-center" style={{
        border: '1px solid rgba(59,130,246,0.3)'
      }} data-id="element-179">
          {/* Header */}
          <div className="px-6 py-5" style={{
          background: 'linear-gradient(135deg, rgb(29,78,216), rgb(37,99,235))'
        }} data-id="element-180">
            <div className="text-4xl mb-2" data-id="element-181">🛡️</div>
            <h2 className="text-lg font-black text-white m-0" data-id="element-182">
              Garantía de 7 días — Sin preguntas
            </h2>
          </div>

          {/* Body */}
          <div className="px-6 py-6" style={{
          backgroundColor: 'rgb(240,249,255)'
        }} data-id="element-183">
            <p className="text-2xl font-black text-blue-700 m-0 mb-2" data-id="element-184">
              Te devolvemos el 100%.
            </p>
            <p className="text-sm text-gray-600 m-0" data-id="element-185">
              Si en 7 días no es lo que esperabas, escribinos y listo.
              <br data-id="element-186" />
              Sin formularios. Sin drama.
            </p>
          </div>
        </div>
      </div>
    </section>;
}